<template>
  <li class="directory-item">
    <div class="directory-row" :class="{ active: isSelected }">
      <b-button
        v-if="hasChildren"
        variant="link"
        class="directory-toggle p-0 mr-2"
        @click="toggle"
      >
        <font-awesome-icon :icon="open ? 'caret-down' : 'caret-right'" />
      </b-button>
      <span v-else class="directory-toggle-placeholder mr-2"></span>
      <span class="directory-label" @click.stop="selectItem">
        <font-awesome-icon :icon="activeIcon" class="mr-2 mt-1" />
        {{ item.nome }}
      </span>
    </div>

    <b-collapse v-if="hasChildren" :visible="open" class="directory-children">
      <ul class="mb-0">
        <list-file-directories-item
          v-for="child in children"
          :key="child.id || child.nome"
          :value="value"
          :item="child"
          :items="items"
          @input="$emit('input', $event)"
        />
      </ul>
    </b-collapse>
  </li>
</template>

<script>
export default {
  name: "ListFileDirectoriesItem",
  props: {
    value: null,
    item: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    isSelected() {
      return this.value === this.item.id;
    },
    children() {
      return this.items.filter(
        (child) => child.file_folder_id === this.item.id
      );
    },
    hasChildren() {
      return this.children.length > 0;
    },
    activeIcon() {
      return this.isSelected || this.open ? "folder-open" : "folder";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.hasSelectedDescendant()) {
          this.open = true;
        }
      },
    },
  },
  methods: {
    selectItem() {
      const nextValue = this.isSelected ? null : this.item.id;
      this.$emit("input", nextValue);
    },
    toggle() {
      this.open = !this.open;
    },
    hasSelectedDescendant(parentId = this.item.id) {
      return this.items.some((child) => {
        if (child.file_folder_id !== parentId) {
          return false;
        }

        if (child.id === this.value) {
          return true;
        }

        return this.hasSelectedDescendant(child.id);
      });
    },
  },
};
</script>
